import axios from "axios";
import type { SignupPayload, SignupSuccess, SignupError } from "./postSignup.d";

export default async (payload: SignupPayload) => {
  const url = `${process.env.REACT_APP_SIGNUP_SERVICE_BASE_URL}/signup/form?${new Date().getTime()}`;
  const body = { ...payload };

  try {
    const { data } = await axios.post<SignupError | SignupSuccess>(url, body, {
      withCredentials: false,
    });
    return data;
  } catch (message) {
    console.log("🚨 ERROR: ");
    console.dir(message);
    return {
      status: "ERROR",
      error: { message: "Houve um erro ao enviar o seu cadastro" },
    } as SignupError;
  }
};
